import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep2 = (state) => state.get('step2');

const makeSelectStep2 = () =>
  createSelector(selectStep2, (step2State) => ({
    title: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'title']),
      ''
    ),
    firstName: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'firstName']),
      ''
    ),
    surname: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'surname']),
      ''
    ),
    dateOfBirth: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'dateOfBirth']),
      ''
    ),
    addressLine1: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'addressLine1']),
      ''
    ),
    addressLine2: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'addressLine2']),
      ''
    ),
    city: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'city']),
      ''
    ),
    stateProvinceRegion: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'stateProvinceRegion']),
      ''
    ),
    postalZipCode: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'postalZipCode']),
      ''
    ),
    mobile: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'mobile']),
      ''
    ),
    homePhone: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'homePhone']),
      ''
    ),
    workPhone: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'workPhone']),
      ''
    ),
    email: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'email']),
      ''
    ),
    occupation: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'occupation']),
      ''
    ),
    preferredContactNumberForClaim: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'preferredContactNumberForClaim']),
      ''
    ),
    preferredContactEmailForClaim: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'preferredContactEmailForClaim']),
      ''
    ),
    policyNumber: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'policyNumber']),
      ''
    ),
    dateBookedTrip: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'dateBookedTrip']),
      ''
    ),
    dateScheduledToDepart: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'dateScheduledToDepart']),
      ''
    ),
    dateOriginallyScheduled: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'dateOriginallyScheduled']),
      ''
    ),
    plannedDestination: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'plannedDestination']),
      ''
    ),
    totalAmountPaidInAud: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'totalAmountPaidInAud']),
      ''
    ),
    reasonForTrip: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'reasonForTrip']).toJS(),
      ''
    ),
    otherInsurance: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'otherInsurance']),
      ''
    ),
    givePermission: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'givePermission']),
      ''
    ),
    provideDetails: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'provideDetails']),
      ''
    ),
    thirdPartyTitle: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyTitle']),
      ''
    ),
    thirdPartyFirstName: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyFirstName']),
      ''
    ),
    thirdPartySurName: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartySurName']),
      ''
    ),
    thirdPartyDateOfBirth: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyDateOfBirth']),
      ''
    ),
    thirdPartyRelationShip: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyRelationShip']),
      ''
    ),
    thirdPartyAddressLine1: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyAddressLine1']),
      ''
    ),
    thirdPartyAddressLine2: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyAddressLine2']),
      ''
    ),
    thirdPartyCity: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyCity']),
      ''
    ),
    thirdPartyState: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyState']),
      ''
    ),
    thirdPartyPostal: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyPostal']),
      ''
    ),
    thirdPartyMobilePhone: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyMobilePhone']),
      ''
    ),
    thirdPartyHomePhone: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyHomePhone']),
      ''
    ),
    thirdPartyWorkPhone: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyWorkPhone']),
      ''
    ),
    thirdPartyEmail: mapWithDefault(
      step2State,
      () => step2State.getIn(['form', 'thirdPartyEmail']),
      ''
    ),
  }));

const makeSelectStep2Dirty = () =>
  createSelector(selectStep2, (state) => state.get('dirty'));
export { makeSelectStep2, makeSelectStep2Dirty };



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step2/selectors.js